module.exports = process.env.PREFIX || `dk-${process.env.STORYBOOK_THEME || 'sbol'}`;
